/**
 * Copyright (c) 2016-present GlossGenius. All rights reserved.
 */

import * as React from 'react';

import { useAboutPage } from 'hooks/page/about/useAboutPage';

import { AvgRating } from './components/AvgRating';
import { Banners } from './components/Banners';
import { CancellationPolicy } from './components/CancellationPolicy';
import { ClassicBusinessHoursSection } from './components/ClassicBusinessHoursSection';
import { ClassicReviewList } from './components/ClassicReviewList';
import { GiftCards } from './components/GiftCards';
import { InfoBlock } from './components/InfoBlock';

import s from './ClassicAbout.module.css';

const ClassicAbout = () => {
  const {
    areGiftCardsEnabled,
    showReviews,
    aboutText,
    hasCancellationPolicy,
    avgRating,
  } = useAboutPage();

  const hasAboutText = aboutText?.length > 0;

  return (
    <>
      <main className={s.root}>
        {areGiftCardsEnabled && <GiftCards />}
        {showReviews && <AvgRating avgRating={avgRating} />}
        {hasAboutText && (
          <InfoBlock as="section">
            <h2 className="hidden">About</h2>
            {aboutText}
          </InfoBlock>
        )}
        <ClassicBusinessHoursSection />
        {hasCancellationPolicy && <CancellationPolicy />}
        {showReviews && <ClassicReviewList />}
      </main>
      <Banners />
    </>
  );
};

export { ClassicAbout };
